<template>
    <div>
        <q-card class="shadow-0">
            <q-card-section class="row justify-between">
                <div class="text-h6">Mi Perfil <span class="text-subtitle2 text-grey"> (Información del usuario)</span>
                </div>
                <q-btn outline icon="save" label="Guardar" color="primary" class="q-mr-sm" @click="guardarPerfil()" />
            </q-card-section>
            <q-separator />
            <q-card-section>
                <div class="row q-col-gutter-md">
                    <div class="col-12">
                        <q-input dense outlined v-model="form.nombre" label="Nombre(s)" />
                    </div>
                    <div class="col-12">
                        <q-input dense outlined v-model="form.apellidos" label="Apellidos" />
                    </div>
                    <div class="col-12">
                        <q-input dense outlined v-model="form.email" label="Correo electrónico" type="email" />
                    </div>
                    <div class="col-12">
                        <q-input dense outlined v-model="form.telefono" mask="(###) ### - ####" label="Teléfono" />
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </div>
</template>

<script>
import axios from 'axios'
import { QSpinnerClock } from 'quasar'

export default {
    name: 'PerfilUsuario',
    data() {
        return {
            form: {
                nombre: '',
                apellidos: '',
                email: '',
                telefono: ''
            }
        }
    },
    computed: {
        adminStore() {
            return this.$store.state.auth.clienteStore;
        },
    },
    methods: {
        async guardarPerfil() {
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Guardando información. Espere...', messageColor: 'white' })
            try {
                await axios.put('Configuracion/UpdateUsuarioAsync/' + this.form._id_cliente, this.form)
                this.$q.loading.hide()

                this.$q.notify({ type: 'positive', position: 'top-right', message: 'Datos guardados correctamente' })
            } catch (err) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', message: 'Error al actualizar perfil' })
            }
        },
        async obtenerPerfil() {
            try {
                const res = await axios.get('Configuracion/GetUsuarioPorId/' + this.adminStore._id_cliente)
                this.form = res.data
            } catch (err) {
                console.error('Error al obtener perfil:', err)
            }
        }
    },
    mounted() {
        this.obtenerPerfil()
    },

}
</script>